import React from 'react';
import classNames from 'classnames';

import css from './IconFilePDF.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "IconFilePDF" icon
 */
const IconFilePDF = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="48"
      height="45"
      viewBox="0 0 48 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83301 21.1673C5.83301 14.8819 5.83301 11.7392 7.90767 9.7866C9.98232 7.83398 13.3214 7.83398 19.9997 7.83398H21.2875C26.7228 7.83398 29.4405 7.83398 31.3278 9.16372C31.8687 9.5447 32.3487 9.99652 32.7535 10.5055C34.1663 12.2818 34.1663 14.8396 34.1663 19.9552V24.1977C34.1663 29.1363 34.1663 31.6055 33.3848 33.5777C32.1283 36.7483 29.4712 39.2492 26.1023 40.4317C24.007 41.1673 21.3833 41.1673 16.136 41.1673C13.1376 41.1673 11.6384 41.1673 10.441 40.747C8.51599 40.0713 6.99759 38.6422 6.27961 36.8305C5.83301 35.7035 5.83301 34.2925 5.83301 31.4703V21.1673Z"
        stroke="#8BA4BB"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M34.1667 24.5C34.1667 27.5682 31.6793 30.0555 28.6112 30.0555C27.5015 30.0555 26.1933 29.8612 25.1143 30.1502C24.1558 30.407 23.407 31.1558 23.1502 32.1143C22.8612 33.1933 23.0555 34.5015 23.0555 35.6112C23.0555 38.6793 20.5682 41.1667 17.5 41.1667"
        stroke="#8BA4BB"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="16" y="0.5" width="32" height="21" rx="4" fill="#297DDC" />
      <path
        d="M21.4142 15.5V6.77273H24.3631C25.0478 6.77273 25.6074 6.89631 26.0421 7.14347C26.4796 7.38778 26.8034 7.71875 27.0137 8.13636C27.2239 8.55398 27.329 9.01989 27.329 9.53409C27.329 10.0483 27.2239 10.5156 27.0137 10.9361C26.8063 11.3565 26.4853 11.6918 26.0506 11.9418C25.6159 12.1889 25.0591 12.3125 24.3801 12.3125H22.2665V11.375H24.3461C24.8148 11.375 25.1912 11.294 25.4753 11.1321C25.7594 10.9702 25.9654 10.7514 26.0932 10.4759C26.2239 10.1974 26.2892 9.88352 26.2892 9.53409C26.2892 9.18466 26.2239 8.87216 26.0932 8.59659C25.9654 8.32102 25.758 8.10511 25.4711 7.94886C25.1841 7.78977 24.8034 7.71023 24.329 7.71023H22.4711V15.5H21.4142ZM31.7246 15.5H29.0314V6.77273H31.8439C32.6905 6.77273 33.415 6.94744 34.0172 7.29688C34.6195 7.64347 35.0811 8.14205 35.4022 8.79261C35.7232 9.44034 35.8837 10.2159 35.8837 11.1193C35.8837 12.0284 35.7218 12.8111 35.3979 13.4673C35.074 14.1207 34.6025 14.6236 33.9831 14.9759C33.3638 15.3253 32.611 15.5 31.7246 15.5ZM30.0882 14.5625H31.6564C32.378 14.5625 32.976 14.4233 33.4505 14.1449C33.9249 13.8665 34.2786 13.4702 34.5115 12.956C34.7445 12.4418 34.861 11.8295 34.861 11.1193C34.861 10.4148 34.7459 9.80824 34.5158 9.29972C34.2857 8.78835 33.9419 8.39631 33.4846 8.12358C33.0272 7.84801 32.4576 7.71023 31.7757 7.71023H30.0882V14.5625ZM37.6564 15.5V6.77273H42.8894V7.71023H38.7132V10.6591H42.4973V11.5966H38.7132V15.5H37.6564Z"
        fill="white"
      />
    </svg>
  );
};

export default IconFilePDF;
